import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BaseComponent } from 'src/app/base/base.component';
import { HistoryBaseComponent } from 'src/app/history-base/history-base.component';
import { Card } from 'src/models/DTO/card/Card';
import { PlainContactV2 } from 'src/models/DTO/contact/plainContactV2';
import { OrderInfo } from 'src/models/DTO/orders/orderInfo';
import { UserDTO } from 'src/models/DTO/user/user';
import { CreateGroupOrderRequestModel } from 'src/models/requestModels/groups/CreateGroupOrderRequestModel';
import { SpeedyService } from 'src/services/request/speedy/speedy.service';
import { GroupStateService } from 'src/services/state/group/group-state.service';
import { HistoryService } from 'src/services/state/history/history.service';
import { LoggedUserService } from 'src/services/state/loggeduser/loggeduser.service';
import { OrederStateService } from 'src/services/state/order/oreder-state.service';


const CT_PALLET = 413;
const CT_TYRES  = 704;
const CARD_ONLY_THRESHOLD = 500;

@Component({
  selector: 'app-orderdetails',
  templateUrl: './orderdetails.component.html',
  styleUrls: ['./orderdetails.component.css']
})
export class OrderdetailsComponent extends HistoryBaseComponent implements OnInit {

  private _order?: OrderInfo;
  private _loggedUser?: UserDTO;
  private _isGroup?: boolean;
  public readonly cardOnlyThreshold = CARD_ONLY_THRESHOLD;

  constructor(
    private orderStateService: OrederStateService,
    private router: Router,
    private loggedUserService: LoggedUserService,
    private speedyService: SpeedyService,
    private modalService: NgbModal,
    private activatedRoute: ActivatedRoute,
    private groupOrderStateService: GroupStateService,
    protected location: Location,
    protected historyService: HistoryService
  ) {
    super(location, historyService);
    this._pageTitle = 'order_home';
    this.orderStateService.orderInfo$.subscribe((order) => {
      this._order = order;
    });
    this.loggedUserService.userInfo$.subscribe((user) => {
      this._loggedUser = user;
    });
  }

  get officeRestricted(): boolean {
    const lines = (this._order as any)?.cart?.lines || [];
    return lines.some((l: any) => {
      const weight = Number(
        l?.sku?.product?.packaging?.dimensions?.weight ?? NaN
      );
      const type = Number(
        l?.sku?.product?.packaging?.courier_services?.other_options?.type ?? NaN
      );
      return type === CT_PALLET || type === CT_TYRES || weight >= 32;
    });
  }

  get isGroupOrder(): boolean {
    return !!this._isGroup;
  }

  get productsTotal(): number {
    const cart = (this._order as any)?.cart;
    if (!cart || !Array.isArray(cart.lines)) {
      return 0;
    }

    return cart.lines.reduce((total: number, line: any) => {
      const price = Number(line?.price_per_piece ?? 0);
      const quantity = Number(line?.quantity ?? 0);

      return total + (price * quantity);
    }, 0);
  }

  get isCardOnlyPayment(): boolean {
    return this.isGroupOrder || this.productsTotal >= this.cardOnlyThreshold;
  }

  ngOnInit(): void {

    this.activatedRoute.params.subscribe(params => {
      if (params.group) {
        this._isGroup = true;
      }
      else {
        this.groupOrderStateService.orderInfo$.subscribe(group => {
          if (group.sku.uuid) {
            this._isGroup = true;
          }
        });
      }
    });

    this.orderStateService.orderInfo$.subscribe(order => {
      this._order = order;
      if (!this._order) { return; }

      if (this.officeRestricted && this._order.toCarrierOffice) {
        this._order.toCarrierOffice = false;
        this._order.toAddress = true;
      }
      this.ensureValidPaymentMethod();
    });
  }

  private ensureValidPaymentMethod(): void {
    if (!this._order) {
      return;
    }

    if (this.isCardOnlyPayment) {
      this._order.cardPayment = true;
      this._order.cashPayment = false;
    } else {
      if (!this._order.cardPayment && !this._order.cashPayment) {
        this._order.cashPayment = true;
        this._order.cardPayment = false;
      }
    }
  }

  get order() {
    // console.log('this._order--->', this._order);
    return this._order;
  }

  back(): void {
    if (!this._isGroup) {
      this.router.navigate(['bottomtabs/cart']).then(() => {
        this.historyService.deleteLastRoute();
        this.historyService.clearToCart();
      });
    }
    this.groupOrderStateService.removeOrderInfo();
    this.historyService.deleteLastRoute();
    this.historyService.clearToCart();
    super.back();
  }

  toOffice(modal: any): void {
    if (this.officeRestricted) {
      return;
    }
    this._order!.toAddress =  false;
    this._order!.toCarrierOffice = true;
    modal.close();
  }

  toHome(modal: any) {
    this._order!.toAddress =  true;
    this._order!.toCarrierOffice = false;
    modal.close();
  }

  toCard(modal: any): void {
    this._order!.cardPayment =  true;
    this._order!.cashPayment = false;
    modal.close();
  }

  toCod(modal: any): void {
    if (this.isCardOnlyPayment) {
      return;
    }
    this._order!.cashPayment =  true;
    this._order!.cardPayment = false;
    modal.close();
  }

  areDetalsFilled(): boolean {
    if (this._order!.toAddress && !this._order!.contactUUID) {
      return false;
    }
    if (this._order!.toCarrierOffice && !this._order!.carrierOfficeAddress) {
      return false;
    }
    if (this._order!.cardPayment && !this._order!.paymentCard) {
      return false;
    }
    return true;
  }

  continue(): void {
    if (this._isGroup) {
      this.router.navigate(['order/precomplete/group']);
      return;
    }
    this.orderStateService.addNewOrderInfo(this._order!);
    this.router.navigate(['order/precomplete']);
  }

  cooseAddress(): void {
    this.orderStateService.addNewOrderInfo(this._order!);
    if (this.order?.toCarrierOffice){
      this.router.navigate(['order/pickup']);
    }
    else {
      this.router.navigate(['order/adderess/select/SHIPPING']);
    }
  }

  cooseInvoiceAddress(): void {
    this.orderStateService.addNewOrderInfo(this._order!);
    this.router.navigate(['order/adderess/select/INVOICE']);
  }

  cooseCard(): void {
    this.orderStateService.addNewOrderInfo(this._order!);
    this.router.navigate(['payments/card/select']);
  }

  toggleSameInvoice(event: any): void {
    this.order!.isNewInvoiceAddress = !this.order!.isNewInvoiceAddress;
  }

  getAddressString() {
    // return address.city + ', ' + address.post_code + ', ' + address.country?.name
    return this.order?.address;
  }

  getInvoiceAddressString() {
    // return address.city + ', ' + address.post_code + ', ' + address.country?.name
    return this.order?.invoiceAddress;
  }

  getNameAsString(): string {
    return this._loggedUser?.data.fist_name + ' ' + this._loggedUser?.data.last_name;
  }

  getTelAsString(address: PlainContactV2) {
    return address.mobile_phone_1_e164;
  }

  public open(modal: any): void {
    this.modalService.open(modal, { size: 'sm',  windowClass: 'loginModal' });
  }

  public cardImg(card: Card): string {
    let cardImage = '/assets/images/cards/card-mastercard.svg';
    if (card.card.brand === 'visa') {
      cardImage = '/assets/images/cards/card-visa.svg';
    }
    return cardImage;
  }

  public getCardDetail(card: Card): string {
    let cardName = 'MASTERCARD *';
    if (card.card.brand === 'visa') {
      cardName = 'VISA DEBIT *';
    }
    return cardName + card.card.last4;
  }
}
